import { render, staticRenderFns } from "./move-stock-modal.vue?vue&type=template&id=1899ffc9&scoped=true"
import script from "./move-stock-modal.vue?vue&type=script&lang=js"
export * from "./move-stock-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899ffc9",
  null
  
)

export default component.exports